
export  const getDirectionColor = (direction) => {
    switch (direction) {
      case 'incoming': return 'bg-green-100 text-green-700';
      case 'outgoing': return 'bg-blue-100 text-blue-700';
      default: return 'bg-gray-100 text-gray-700';
    }
  };



export const translateDirection = (direction) => {
    switch (direction) {
      case 'incoming': return 'وارد';
      case 'outgoing': return 'صادر';
      default: return '-';
    }
  };
